module.exports = __webpack_public_path__ + "static/img/notice.11ab9c7b.png";